import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/Home/avatar.webp";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
               PERMETTEZ-MOI DE ME <span className="purple"> PRÉSENTER </span> 
            </h1>
            <p className="home-about-body">
              Titulaire d’une licence professionnelle en 
              <i>
                <b className="purple">
                  {" "}
                  Administration et Sécurité des Réseaux,{" "}
                </b>
              </i>
              je suis champion régional et classé 5ᵉ au niveau national lors de la 46ᵉ édition des Olympiades des Métiers (WorldSkills) dans le métier de l’administration des systèmes et des réseaux informatiques.
	      <br />
              <br />
	      Je suis également
              <i>
                <b className="purple">
                  {" "}
                  membre de l’équipe de Nouvelle-Aquitaine{" "}
                </b>
              </i>
	      pour le métier de
              <i>
                <b className="purple">
                  {" "}
                  l’administration des systèmes et des réseaux informatiques,{" "}
                </b>
              </i>
              ainsi
              <i>
                <b className="purple">
                  {" "}
                  qu’expert Europe pour WorldSkills France{" "}
                </b>
              </i>
              dans le métier
              <i>
                <b className="purple">
                  {" "}
                  IT Network Systems Administration{" "}
                </b>
              </i>
	      aux EuroSkills.
              <br />
              <br />
	      Mes domaines de compétence sont : l’administration de systèmes 
              <i>
                <b className="purple">
                  {" "}
                  (Windows et Linux),{" "}
                </b>
              </i>
              l’administration de réseaux
              <i>
                <b className="purple">
                  {" "}
                  (Cisco, Stormshield et UniFi),{" "}
                </b>
              </i>
	      la conception d’infrastructures
              <i>
                <b className="purple">
                  {" "}
                  (systèmes et réseaux){" "}
                </b>
              </i>
	      et la supervision
              <i>
                <b className="purple">
                  {" "}
                  (Nagios et Zabbix).{" "}
                </b>
              </i>
              <br />
              <br />
            </p>
          </Col>          
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
